import { css, keyframes } from '@emotion/core';
import randomInteger from '../utils/randomInteger';

interface ProgressiveLoadingOptions {
  primaryColor?: string;
  secondaryColor?: string;
  randomWidth?: boolean;
}

export const progressiveLoadingKeyframes = keyframes`
  from {
    background-position: -100vw;
  }
  to {
    background-position: 100vw;
  }
`;

export function progressiveLoading(options?: ProgressiveLoadingOptions) {
  const opts: ProgressiveLoadingOptions = {
    primaryColor: '#fbfbfb',
    secondaryColor: '#f6f6f6',
    randomWidth: false,
    ...options,
  };

  return css`
    animation: ${progressiveLoadingKeyframes} 16s linear infinite;
    background: linear-gradient(
      to right,
      ${opts.secondaryColor} 8%,
      ${opts.primaryColor} 28%,
      ${opts.secondaryColor} 33%
    );
    ${opts.randomWidth ? `width: ${randomInteger(1, 100)}%` : ''};
  `;
}

export default {
  progressiveLoadingKeyframes,
  progressiveLoading,
};
